import DOMPurify from "dompurify"

// Quill's video button emits an <iframe>. Only these providers may keep their. Avoids clickjacking/XSS
const ALLOWED_IFRAME_HOSTS = new Set([
  "www.youtube.com",
  "youtube.com",
  "www.youtube-nocookie.com",
  "youtube-nocookie.com",
  "player.vimeo.com",
])

function isAllowedIframeSrc(src: string): boolean {
  try {
    const url = new URL(src, window.location.origin)
    return (
      url.protocol === "https:" && (ALLOWED_IFRAME_HOSTS.has(url.hostname) || url.hostname.endsWith(".sharepoint.com"))
    )
  } catch {
    return false
  }
}

// After DOMPurify sanitization: enforce safe <a> behavior (open in new tab with security)
// and remove <iframe> elements whose src is not in the allowed whitelist
DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.nodeName === "A") {
    node.setAttribute("target", "_blank")
    node.setAttribute("rel", "noopener noreferrer nofollow")
  }
  if (node.nodeName === "IFRAME" && !isAllowedIframeSrc(node.getAttribute("src") ?? "")) {
    node.remove()
  }
})

// Sanitize user-authored HTML before rendering it with v-html
export function sanitizeHtml(html: string | null | undefined): string {
  return DOMPurify.sanitize(html ?? "", {
    ADD_TAGS: ["iframe"],
    ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling"],
  })
}

